import React from 'react'
import {Typography, Grid} from '@mui/material';
import colors from '../../../../../colors'
import { ReactComponent as NoContractIcon } from '../../../../../../icons/noContracts.svg';
import {texts} from '../../../../../general/texts'

const NoContracts = () => 
{
    return(
        <Grid container item justifyContent={'center'} mt={'15%'}>
            <Grid item md={12} xs={12} pb={'10%'}>
                <NoContractIcon/>
            </Grid>
            <Grid item md={7} xs={7} pb={'14%'}>
                <Typography sx={{color:colors.darkBlue}} variant='h6'>{texts["message-no-favorites"]}</Typography>
            </Grid>                                          
        </Grid>
    )
}
export default NoContracts